export default "__VITE_ASSET__BNm6Eegs__"